import { d as randNorm, S as SYSTEM } from '../common/random-15d3d7f2.js';
import { c as add, i as isNumber } from '../common/add-5cc35f4d.js';
import '../common/codegen-df7bb22c.js';
import '../common/set-c051c4f9.js';

const jitter = (out, a, n = 1, rnd = SYSTEM) => add(out, a, randNorm(new Array(a.length), n, rnd));

/**
 * Produces a number of Poisson-disk samples based on given
 * configuration.
 *
 * @param opts -
 */
const samplePoisson = (_opts) => {
    const opts = Object.assign({ rnd: SYSTEM, iter: 1, jitter: 1, quality: 500 }, _opts);
    const { points, index, rnd, jitter: jitter$1, quality, density: _d } = opts;
    const density = isNumber(_d) ? () => _d : _d;
    const iter = Math.max(opts.iter, 1);
    const samples = [];
    let failed = 0;
    let pos;
    let d;
    let i;
    outer: for (let num = opts.max; num > 0;) {
        pos = points(rnd);
        d = density(pos);
        i = iter;
        while (i-- > 0) {
            if (!index.has(pos, d)) {
                index.add(pos, 0);
                samples.push(pos);
                failed = 0;
                num--;
                continue outer;
            }
            jitter(null, pos, jitter$1, rnd);
        }
        if (++failed > quality) {
            break;
        }
    }
    return samples;
};

export { samplePoisson };
